import router from '../router';

class ErrorHandler {
  static logError(error, context = {}) {
    console.error('Application Error:', {
      message: error.message,
      stack: error.stack,
      context,
      timestamp: new Date().toISOString()
    });

    // In production, you might want to send this to an external logging service
    if (process.env.VUE_APP_ENV === 'production') {
      // Example: Send to external logging service
      // this.sendToLoggingService(error, context);
    }
  }

  static handleApiError(error, context = {}) {
    let errorMessage = 'An unexpected error occurred';
    let errorCode = '500';

    if (error.response) {
      // Server responded with error status
      errorCode = error.response.status.toString();
      errorMessage = error.response.data?.message || error.response.statusText || errorMessage;
    } else if (error.request) {
      // Network error
      errorCode = 'NETWORK';
      errorMessage = 'Unable to connect to server. Please check your internet connection.';
    } else {
      // Other error
      errorMessage = error.message || errorMessage;
    }

    this.logError(error, { ...context, type: 'API_ERROR' });

    return {
      code: errorCode,
      message: errorMessage,
      originalError: error
    };
  }

  static handleRouteError(error, to, from) {
    this.logError(error, { 
      type: 'ROUTE_ERROR',
      to: to.path,
      from: from.path
    });

    // Navigate to error page
    router.push({
      name: 'ErrorPage',
      query: {
        code: '500',
        title: 'Navigation Error',
        message: 'An error occurred while navigating to the requested page.'
      }
    });
  }

  static handleComponentError(error, vm, info) {
    this.logError(error, {
      type: 'COMPONENT_ERROR',
      componentName: vm?.$options.name || 'Unknown',
      info
    });

    // You might want to show a toast notification or redirect to error page
    // depending on the severity of the error
  }

  static showUserFriendlyError(error, fallbackMessage = 'Something went wrong') {
    const errorInfo = typeof error === 'string' ? 
      { message: error } : 
      this.handleApiError(error);

    // Show user-friendly notification (you might use a toast library here)
    alert(errorInfo.message || fallbackMessage);
  }

  static async sendToLoggingService(error, context) {
    try {
      // Example implementation for external logging service
      // Replace with your actual logging service endpoint
      await fetch('/api/logs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          error: {
            message: error.message,
            stack: error.stack,
            timestamp: new Date().toISOString()
          },
          context,
          userAgent: navigator.userAgent,
          url: window.location.href
        })
      });
    } catch (loggingError) {
      console.error('Failed to send error to logging service:', loggingError);
    }
  }
}

export default ErrorHandler;